/**
 * Form validation helper. Run on a form with data-validation attributes on inputs.
 * Uses wp.i18n for translated error messages when available (e.g. when script is localized).
 *
 * @param {string|HTMLElement} formSelectorOrElement - Form selector (e.g. '#mt-embedded-subscribe-form') or form element.
 */
function initValidations(formSelectorOrElement) {
  const form =
    typeof formSelectorOrElement === 'string'
      ? document.getElementById(formSelectorOrElement)
      : formSelectorOrElement

  if (!form) {
    return
  }

  const validations = {
    required(value) {
      return value !== ''
    },
    phone(value) {
      return value.match(
        /^[\+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im
      )
    },
    email(value) {
      return value.match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
    },
  }

  const errorMessage = document.querySelector('.ui.error.message')
  const successMessage = document.querySelector('.ui.success.message')
  const errorClass =
    'ui error message bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative w-full mb-6 text-sm'
  const errorClassHidden = errorClass + ' hidden'

  function getErrorText(ruleName, placeholder) {
    const fallback = `Invalid value '${ruleName}' for input '${placeholder || ''}'`
    if (typeof wp !== 'undefined' && wp.i18n && wp.i18n.sprintf && wp.i18n.__) {
      return wp.i18n.sprintf(
        /* translators: 1: validation rule name, 2: input placeholder or label */
        wp.i18n.__('Invalid value "%1$s" for input "%2$s".', 'rumberg'),
        ruleName,
        placeholder || ''
      )
    }
    return fallback
  }

  form.addEventListener('submit', function (e) {
    const inputsArr = form.querySelectorAll('input')
    let i = 0
    while (i < inputsArr.length) {
      const attr = inputsArr[i].getAttribute('data-validation')
      const rules = attr ? attr.split(' ') : []
      const parent = inputsArr[i].closest('.field')
      let j = 0
      while (j < rules.length) {
        if (!validations[rules[j]](inputsArr[i].value)) {
          e.preventDefault()
          window.scrollTo(0, 0)
          if (errorMessage) {
            errorMessage.className = errorClass
            errorMessage.textContent = getErrorText(
              rules[j],
              inputsArr[i].placeholder
            )
          }
          if (parent) {
            parent.className = 'field error'
          }
          return false
        }
        if (errorMessage) {
          errorMessage.className = errorClassHidden
        }
        if (parent) {
          parent.className = 'field'
        }
        j++
      }
      i++
    }
    if (successMessage) {
      successMessage.className = 'ui success message'
    }
    form.outerHTML = ''
  })
}

const formEl = document.getElementById('mt-embedded-subscribe-form')
if (formEl) {
  initValidations(formEl)
}

export { initValidations }
